
interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
  onClick?: () => void;
}

export default function Card({ children, className = '', hover = false, onClick }: CardProps) {
  return (
    <div 
      onClick={onClick}
      className={`bg-zinc-900/90 rounded-xl shadow-sm border border-zinc-800 ${hover ? 'hover:shadow-lg hover:border-accent-500/60 transition-all duration-300 cursor-pointer' : ''} ${className}`}
    >
      {children}
    </div>
  );
}
